

























































import Snackbar from "buefy/src/components/snackbar/Snackbar.vue";
import { Component, Mixins, Vue } from "vue-property-decorator";
import UserNotification from "@/components/app/global/userNotifications/userNotification.vue";
import { DataModules } from "@/store/modules/data";
import { removeElement } from "buefy/src/utils/helpers";
import Context from "@/mixins/context";
import { mapState } from "vuex";
import { IState } from "@/store";

const SnackbarProgrammatic = Vue.extend(Snackbar);

@Component({
  computed: {
    ...mapState({
      notificationIsFocused: (state: IState) => state.ui.notificationIsFocused
    })
  }
})
export default class UNotification extends Mixins(
  UserNotification,
  SnackbarProgrammatic,
  Context
) {
  public notificationIsFocused!: boolean;

  public shouldQueue() {
    return false;
  }

  public markAsRead() {
    this.$store.dispatch(`data/${DataModules.USER_NOTIFICATIONS}/markRead`, {
      // @ts-ignore
      notification: this.userNotification,
      remove: true
    });
    // @ts-ignore
    this.close(true);
  }

  public close(ignoreFocused = false) {
    // @ts-ignore
    clearTimeout(this.timer);

    if (this.notificationIsFocused && !ignoreFocused) {
      // @ts-ignore
      this.timer = setTimeout(() => this.close(), this.newDuration);
      return;
    }
    // @ts-ignore
    this.isActive = false;
    this.$emit("close");

    // Timeout for the animation complete before destroying
    setTimeout(() => {
      this.$destroy();
      removeElement(this.$el);
    }, 150);
  }
}
